import React from 'react';
import StaggeredTestimonials from './StaggeredTestimonials';

const Testimonials = () => {
  return (
    <StaggeredTestimonials />
  );
};

export default Testimonials;
